import BulkSiteUserAssignmentDialog from "./BulkSiteUserAssignmentFileUploadContainer";

export default BulkSiteUserAssignmentDialog;
